import { useEffect, useRef, useState } from 'react'

export const ErrorMessage = ({ message }: { message: string }) => {
  const total = 588
  const [timeRemaining, setTimeRemaining] = useState(total)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)
  const clear = () => intervalRef.current && clearInterval(intervalRef.current)

  useEffect(() => {
    setTimeRemaining((timeRemaining) => timeRemaining - 1)

    intervalRef.current = setInterval(() => {
      setTimeRemaining((time) => time - 1)
    }, 1)

    return () => {
      clear()
    }
  }, [])

  useEffect(() => {
    if (timeRemaining <= 0) {
      clear()
    }
  }, [timeRemaining])

  return (
    <div className="absolute inset-0 bg-white bg-opacity-50 z-50 flex items-center justify-center">
      <div className="inline-block bg-white rounded-lg shadow-lg">
        <div className="p-4">
          <div className="flex items-center justify-center">
            <svg className="w-8 h-8 text-red-500 animate-pulse" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M9 11h6v2H9z" />
            </svg>

            <p className="ml-2 text-sm text-gray-700">{message}</p>
          </div>
        </div>
        <div className="h-1 bg-white w-[100%]">
          <div className="h-full bg-red-500" style={{ width: `${(timeRemaining / total) * 100}%` }}></div>
        </div>
      </div>
    </div>
  )
}
